<template>
    <li class="radioOption clearfix" @click="$emit('select', value)">
        <div class="radioInner">
            <div class="radioCircle">
                <div v-show="selected()" class="radioCircleInner"></div>
            </div>
            <div class="radioContent">
                <slot/>
            </div>
        </div>

    </li>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import {Prop} from "vue-property-decorator";


    @Component()
    export default class Radio extends Vue {

        @Prop(String) value;
        @Prop(String) selectedValue;

        selected() {
            return this.value === this.selectedValue;
        }
    }
</script>
<style scoped lang="scss">

    .radioOption {
        position: relative;
        margin-right: auto;
        list-style-type: none;

        &:hover {
            cursor: pointer;
        }

        .radioInner {
            margin-left: 0;
            margin-right: auto;
            display: inline-block;
            float: left;

            .radioCircle {
                $size: 25px;
                height: $size;
                width: $size;
                background-color: #F3EFE4;
                border: 2px solid #BB3635;
                border-radius: 50%;
                position: relative;
                display: inline-block;

                .radioCircleInner {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);

                    $innerSize: 12px;
                    height: $innerSize;
                    width: $innerSize;
                    background-color: black;
                    border-radius: 50%;
                }
            }

            .radioContent {
                display: inline-block;
                font-weight: normal;
                margin-left: 25px;
                transform: translateY(-12px);
            }
        }

        &:last-of-type {
            .radioInner {
                .radioCircle {
                    float: left;
                }

                .radioContent {
                    transform: none;
                }
            }
        }

    }

</style>

<style lang="scss">

</style>
